import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NavigationTile.html?raw';
import { TranslationHelpers } from "../../../more/Helpers";

class NavigationTile extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private _callback: Function | string = null;
    private _target: any = null;
    private iconclass: any = null;
    private colorclass: string = "";
    private isActive: boolean = true;

    private labelNode: HTMLElement;
    private iconNode: HTMLElement;
    private iconContainer: HTMLElement;
    private clickableContainer: HTMLElement;

    private data: Navigation.TileData;

    

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(data?: Navigation.TileData): void {
        super.startup.apply(this, arguments as any);

        if (typeof (data) != "undefined") {
            this.applyData(data);
        }
    }

    applyData(data: Navigation.TileData): void {
        if (!data) return;

        this.data = data;


        this.clickableContainer.setAttribute("data-cy", "navigationTile:" + (data.label ?? ""));

        //if (!data.width) {
        //    data.width = "10ch";
        //}

        if (typeof (data.label) != "undefined") {
            if (TranslationHelpers.canTranslate(data.label)) data.label = TranslationHelpers.translate(data.label);
            this._setLabelAttr(data.label);
        }
        // if (data.actionType) {

        // }
        if (typeof (data.target) != "undefined") {
            this._setTargetAttr(data.target, true);
        }

        if (typeof (data.callback) == "function") {
            this._setCallbackAttr(data.callback);
        }

        if (typeof (data.iconclass) != "undefined") {
            this._setIconAttr( data.iconclass);
        }

        if (typeof (data.colorclass) != "undefined") {
            this._setColorAttr(data.colorclass);
        }

        if (!data.colorclass && data.colorBG) {
            this._setColorBGAttr( data.colorBG);
        }
        if (!data.colorclass && data.colorTXT) {
            this._setColorTXTAttr(data.colorTXT);
        }

        if( typeof(data.width) == "string") this.domNode.style.setProperty("--widthBase", data.width);
        this.UiModder.domClass.toggle(this.domNode, "strict", data.widthMode == "strict");
        this.UiModder.domClass.toggle(this.domNode, "useMaxWidth", data.widthMode == "useMaxWidth");
        this.UiModder.domClass.toggle(this.domNode, "useMinWidth", data.widthMode == "useMinWidth");



    //    if (data.widthMode == "strict") {
    //        if (data.width) {
    //            this.UiModder.domStyle.set(this.domNode, "maxWidth", data.width);
    //            this.UiModder.domStyle.set(this.domNode, "minWidth", data.width);
    //        }
    //    }
    //    else if (data.widthMode == "useMaxWidth") {
    //        if (data.width) {
    //            this.UiModder.domStyle.set(this.domNode, "maxWidth", data.width);
    //        }
    //    } else if (data.widthMode == "useMinWidth") {
    //        if (data.width) {
    //            this.UiModder.domStyle.set(this.domNode, "minWidth", data.width);
    //        }
    //    }
    //    else {
    //        this.UiModder.domStyle.set(this.domNode, "minWidth", "");
    //        this.UiModder.domStyle.set(this.domNode, "maxWidth", "");
    //        this.UiModder.domStyle.set(this.domNode, "width", "");
    //    }
    }

    private _setLabelAttr(value) {
        this.UiModder.domAttr.set(this.labelNode, "innerHTML", value);
    }

    private _setIconAttr(value) {

        if (!value) return;
        if (this.iconclass != null) {
            this.UiModder.domClass.remove(this.iconNode, this.iconclass);
        }

        // sondervalues?
        if (value.includes("profilePic")) {
            // PROFILBILD REINLADEN!
            if (window.sessionInfo) {
                window.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));
            }
        }

        this.iconclass = value;

        if (this.iconclass) {
            this.UiModder.domClass.add(this.iconNode, this.iconclass);
            this.UiModder.domClass.remove(this.iconContainer, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.iconContainer, "w3-hide");
        }
    }

    private setProfilePic(data: { base64: string }) {
        let userIconNode = this.iconNode;

        //if (data) {
        //    console.debug("navigation setprofilpic", data.checksum);
        //}

        if (userIconNode) {
            this.UiModder.domConstruct.empty(userIconNode);
        }

        if (data) {
            if (userIconNode && data.base64) {
                let picOverlay = this.UiModder.domConstruct.create("img", {
                    "src": "data:image/jpeg;base64," + data.base64,
                    "className": "profilePic round"
                }, userIconNode);
            }
        }
    }

    private _setTargetAttr(value: string, bUseApproot) {
        if (bUseApproot === true && value) {
            value = window.appRoot + value;
        }

        if (value != null && value != "") {
            this._setCallbackAttr("href");
            this._target = value;
            this.UiModder.domAttr.set(this.clickableContainer, "href", this._target);
        } else {
            /*this.set("callback", null);*/
            this._target = value;
            this.UiModder.domAttr.remove(this.clickableContainer, "href");
        }
    }

    private _setCallbackAttr(value) {

        this._callback = value;

        var bSetActive = true;
        bSetActive = typeof (this._callback) == "function" || this._callback == "href";
        if (bSetActive) {
            this._setTargetAttr(null, false);
        }

        this.set("isActive", bSetActive);
    }

    private _setColorAttr(value) {
        if (this.colorclass != null) {
            this.UiModder.domClass.replace(this.clickableContainer, "directColor", this.colorclass);
        }

        this.colorclass = value;

        if (this.colorclass != null) {
            
            this.UiModder.domClass.replace(this.clickableContainer, this.colorclass, "directColor");
            let compute = getComputedStyle(this.clickableContainer);
            this.clickableContainer.style.setProperty("--bgColor", compute.backgroundColor);
            this.clickableContainer.style.setProperty("--txtColor", compute.color);
            this.UiModder.domClass.add(this.clickableContainer, "directColor"); // immer hinzufügen nach Berechnung, für darkmode
        }
    }

    private _setColorBGAttr(value) {
        if (this.colorclass != null) {
            this.UiModder.domClass.replace(this.clickableContainer, "directColor", this.colorclass);
            this.clickableContainer.style.removeProperty("--bgColor");
        }

        //this.UiModder.domStyle.set(this.clickableContainer, "background", value);
        this.clickableContainer.style.setProperty("--bgColor", value);
    }

    private _setColorTXTAttr(value) {
        if (this.colorclass != null) {
            this.UiModder.domClass.replace(this.clickableContainer, "directColor", this.colorclass);
            this.clickableContainer.style.removeProperty("--txtColor");
        }

        //this.UiModder.domStyle.set(this.clickableContainer, "color", value);
        this.clickableContainer.style.setProperty("--txtColor", value);
    }

    private _setIsActiveAttr(value) {
        this.isActive = value === true;

        if (this.isActive == true) {
            this.UiModder.domClass.remove(this.clickableContainer, "w3-disabled")
            this.UiModder.domClass.add(this.clickableContainer, "hoverBright")
        } else {
            this.UiModder.domClass.add(this.clickableContainer, "w3-disabled")
            this.UiModder.domClass.remove(this.clickableContainer, "hoverBright")
        }
    }

    private _onClick_clickableContainer(evt) {
        
        if (this.isActive !== true) {
            return;
        }

        this.UiModder.domClass.add(this.domNode, "clicked");
        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "clicked"), 4500);


        if (typeof (this._callback) == "function") {
            setTimeout(lang.hitch(this, this._callback, this.data), 100);
        } else if (this._callback == "href") {
            setTimeout(lang.hitch(this, function () { window.location = this._target }), 100);
        }



        this.emit("click", this.data);
    }

}

export default mdsWidget(NavigationTile);